// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the Models.tst template. 
// !!!!!! Do not modify this file or change will probably be lost !!!!!!
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import Validator from './Validator';
import MinMaxDTO from './MinMaxDTO';
import EntitySelectorDTO from './EntitySelectorDTO';

interface IowaVariationDataTableDTO extends EntitySelectorDTO { 
	id: number;
	order: number;
	code: string | null;
	name: string | null;
	specialUse: boolean;
}

const IowaVariationDataTableDTO = {
    className: 'IowaVariationDataTableDTO',
    create: (initValues?: Partial<IowaVariationDataTableDTO> | Record<string, unknown> | null) => {
        return Object.assign(EntitySelectorDTO.create(),
        {
			id: 0,
			order: 0,
			code: "",
			name: "",
			specialUse: false,
        },
        initValues);
    },
	id: 'id',
	order: 'order',
	code: 'code',
	name: 'name',
	specialUse: 'specialUse',
};

export default IowaVariationDataTableDTO;